import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@shared/components/ui/shadcn/accordion';
import { Alert, AlertTitle, AlertDescription } from '@shared/components/ui/shadcn/alert';
import { RadioGroup, RadioGroupItem } from '@shared/components/ui/shadcn/radio-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Label } from '@shared/components/ui/label';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@shared/hooks/usePermissions';

export const GroupingAccordion = () => {
  const { t } = useTranslation('generalModule');
  const { canAccess } = usePermissions();

  // 🎯 Verificar permiso de edición
  const canEdit = canAccess(['tenant', 'tenant_3pl'], ['configuration.edit']);

  return (
    <>
      <h2 className="text-2xl font-semibold mb-4">{t('grouping.title')}</h2>
      <Accordion type="multiple" defaultValue={['multiple-criteria']} className="w-full">
        <AccordionItem value="multiple-criteria">
          <AccordionTrigger>{t('grouping.multiple_criteria')}</AccordionTrigger>
          <AccordionContent className="space-y-4">
            <Alert variant="default">
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon={faCircleInfo} className="text-muted-foreground mt-1 w-4 h-4" />
                <div>
                  <AlertTitle>{t('grouping.multiple_criteria_alert_title')}</AlertTitle>
                  <AlertDescription>{t('grouping.multiple_criteria_alert_description')}</AlertDescription>
                </div>
              </div>
            </Alert>

            <RadioGroup defaultValue="distinct" className="space-y-2" disabled={!canEdit}>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="distinct" id="distinct" />
                <Label htmlFor="distinct">{t('grouping.radio.distinct')}</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="multiple-units" id="multiple-units" />
                <Label htmlFor="multiple-units">{t('grouping.radio.multiple_units')}</Label>
              </div>
            </RadioGroup>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="packs-or-products">
          <AccordionTrigger>{t('grouping.show_packs')}</AccordionTrigger>
          <AccordionContent className="space-y-4">
            <Alert variant="default">
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon={faCircleInfo} className="text-muted-foreground mt-1 w-4 h-4" />
                <div>
                  <AlertTitle>{t('grouping.show_packs_alert_title')}</AlertTitle>
                  <AlertDescription>{t('grouping.show_packs_alert_description')}</AlertDescription>
                </div>
              </div>
            </Alert>

            <RadioGroup defaultValue="show_packs" className="space-y-2" disabled={!canEdit}>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="show_packs" id="show_packs" />
                <Label htmlFor="show_packs">{t('grouping.radio.show_packs')}</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="show_products" id="show_products" />
                <Label htmlFor="show_products">{t('grouping.radio.show_products')}</Label>
              </div>
            </RadioGroup>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  );
};
